import React from 'react';
import emailjs, { init } from 'emailjs-com';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from '../components/common/index'
require("dotenv").config();

function FeedbackForm() {
   const userId = process.env.USER_ID;
   const template = process.env.TEMPLATE_ID;
   const serviceId = process.env.SERVICE_ID;
   init(userId);

   const [data, setData] = React.useState({
      email: '',
      feedback: '',
      status: 'idle'
   })
   const { email, feedback, status } = data;

   function sendEmail(e) {
      e.preventDefault();
      let templateParams = {
         from_name: email,
         message: feedback,
      }
      if (feedback && email) {
         setData(currentValues => ({
            ...currentValues,
            status: 'pending'
         }))
         // new Promise(r =>
         //    setTimeout(r, 3000)).then(() => setData({ status: 'resolved' }))

         emailjs.send(serviceId, template, templateParams)
            .then(() => {
               setData({ status: 'resolved' });
            }, (error) => {
               setData({ status: 'rejected' });
               console.log(error.text);
            });
      }
   }
   const handleChange = (e) => {
      setData({
         ...data,
         [e.target.name]: e.target.value
      });
   }
   if (status === 'idle') {
      return (
         <Container fluid="md">
            <Row>
               <Col></Col>
               <Col md="auto">
                  <FormWrapper id="contact-us">
                     <h5>Ajută-ne să fim mai buni!<span aria-label='heart' role='image'>♥️</span></h5>
                     <h6>Dacă ai vreo părere, sugestie sau vrei să ne transmiți ceva -
               <br />scrie și apasă pe butonul 'TRIMITE'</h6>
                     <form onSubmit={sendEmail}>
                        <div className="form-name">
                           <label htmlFor="email"></label>
                           <input name="email" id="email" type="email"
                              value={data.email}
                              onChange={handleChange}
                              required
                              placeholder="Emailul tau..." ></input>
                           <label htmlFor="feedback"></label>
                           <textarea name="feedback" id="feedback"
                              value={data.feedback}
                              required
                              onChange={handleChange}
                              placeholder="Mesajul tău aici..." rows="4" ></textarea>

                        </div>
                        <Button type="submit" >Trimite {'  '}
                           <span aria-label='rocket' role='image'>🚀</span>
                        </Button>
                     </form>
                  </FormWrapper>
               </Col>
               <Col></Col>
            </Row>
         </Container>
      );
   } else if (status === 'pending') {
      return (
         <Container fluid="md">
            <Row>
               <Col></Col>
               <Col md="auto">
                  <FormWrapper id="contact-us">
                     <p style={{ marginBottom: "3rem" }}>Am impachetat mesajul si l-am trimis</p>
                  </FormWrapper>
               </Col>
               <Col></Col>
            </Row>
         </Container>)
   } else if (status === 'resolved') {
      return (
         <Container fluid="md">
            <Row>
               <Col></Col>
               <Col md="auto">
                  <FormWrapper id="contact-us">
                     <p style={{ marginBottom: "3rem" }}>Multumim! 🙏<br />Mesajul a fost transmis </p>
                  </FormWrapper>
               </Col>
               <Col></Col>
            </Row>
         </Container>)
   } else if (status === 'rejected') {
      return (
         <Container fluid="md">
            <Row>
               <Col></Col>
               <Col md="auto">
                  <p style={{ marginBottom: "3rem" }}>A aparut o eroare. Te rog sa dai refresh si sa incerci din nou</p>
               </Col>
               <Col></Col>
            </Row>
         </Container>)
   }
}

const FormWrapper = styled.div`
        display:grid;
        justify-self:center;
        justify-content:center;
        text-align:center;
        margin:20px auto;
   
       h6{
          font-size:.6rem;
          width: 80%;
          margin: auto;
       }
    form{
        display:grid;
        grid-template-columns:repeat(1, auto);
        grid-template-rows:1fr;
        align-items:center;
        justify-self:center;
        grid-gap:15px;
        margin-bottom:10px;
        .form-name {
            display:grid;
            grid-template-rows:repeat(2, auto);
            font-size:var(--font-size);
        button{
         width:300px;
        }
        textarea, input{
            border:solid 1px grey;
            border-radius:5px;
            width:300px;
            font-size:16px;
        }
        
        
    }
    
}
`
export default React.memo(FeedbackForm);